import React, { PropsWithChildren, ReactNode } from 'react';
import theme from './SimpleFormPage.module.scss';
import { PageTitle, SimplePageTitle } from '@/components/layout/PageTitle';
import { classnames } from '@ygtechnologies/bygr-frontend-component-library';

interface SimpleFormPageProps extends PropsWithChildren {
    header?: string;
    cardClassName?: string;
}

const SimpleFormPage: React.FC<SimpleFormPageProps> = ({ children, header, cardClassName }) => {
    return (
        <>
            {header && <SimplePageTitle title={header} />}
            <div className={classnames(theme.card, cardClassName)}>
                <div>{children}</div>
            </div>
        </>
    );
};

export default SimpleFormPage;
